export enum ErrorStatus {
    Timeout = "timeout",
    LoadError = "loadError"
}
